import { classNames } from 'shared/lib/classNames/classNames';
import { useDispatch, useSelector } from 'react-redux';
import { getPlotStepData, plotStepData, plotStepsActions } from 'widgets/PlotSteps';
import { KeyboardEvent, useEffect, useState } from 'react';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import { useApi } from 'app/api/APIProvider';
import cls from './WorkSchedule.module.scss';

interface WorkScheduleProps {
    className?: string
}

export const WorkSchedule = (props: WorkScheduleProps) => {
    const {
        className,
    } = props;
    const dispatch = useDispatch();
    const stepData = useSelector(getPlotStepData);
    const [selectedSchedule, setSelectedSchedule] = useState<number>(2);
    const [scheduleType, setScheduleType] = useState<string>('pizza');
    const api = useApi();
    const user = api.User;

    const nextStepHandler = (linkOnStep: number) => {
        api.EditUser({
            current_scene: {
                plotStep: linkOnStep,
            },
            profession: `${user.profession}_${selectedSchedule}`,
        }).then(() => {
            dispatch(plotStepsActions.addedPlotStepData(plotStepData(linkOnStep, user)));
        }).catch((error) => {
            console.log(error);
        });
    };

    useEffect(() => {
        api.GetUser().then((res) => {
            setScheduleType(res.profession);
        });
    }, []);

    const getSumWithRubble = (value: number): string => value
        .toLocaleString('ru-RU', { style: 'currency', currency: 'RUB', minimumFractionDigits: 2 });

    return (
        <div className={classNames(cls.WorkSchedule, {}, [className])}>
            <div className={cls.content}>
                <div className={cls.speaker}>
                    <img className={cls.speakerImg} src={stepData?.action?.speakerImg} alt="Персонаж" />
                </div>
                <div className={cls.info}>
                    <div className={cls.title}>
                        {stepData?.action?.title}
                    </div>
                    <div className={cls.actionContent}>
                        <div className={cls.workName}>
                            {stepData?.action?.workName[scheduleType]}
                        </div>
                        <div className={cls.list}>
                            {stepData?.action?.schedules[scheduleType]?.map((item: any) => (
                                <div
                                    key={item.scheduleId}
                                    onClick={() => setSelectedSchedule(item.hours)}
                                    onKeyDown={(e:KeyboardEvent<HTMLElement>) => e.code === 'Enter' && setSelectedSchedule(item.hours)}
                                    role="button"
                                    tabIndex={0}
                                    className={classNames(cls.item, { [cls.active]: selectedSchedule === item.hours }, [className])}
                                >
                                    <div className={cls.el}>
                                        <div className={cls.name}>
                                            Рабочих часов в день
                                        </div>
                                        <div className={cls.value}>
                                            {item.hours}
                                        </div>
                                    </div>
                                    <div className={cls.el}>
                                        <div className={cls.name}>
                                            Оплата в день
                                        </div>
                                        <div className={cls.value}>
                                            {getSumWithRubble(item.paymentPerDay)}
                                        </div>
                                    </div>
                                    <div className={cls.el}>
                                        <div className={cls.name}>
                                            Оплата за месяц
                                        </div>
                                        <div className={cls.value}>
                                            {getSumWithRubble(item.paymentPerMonth)}
                                        </div>
                                    </div>
                                    <div className={cls.el}>
                                        <div className={cls.name}>
                                            Оплата за год
                                        </div>
                                        <div className={cls.value}>
                                            {getSumWithRubble(item.paymentPerYear)}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <Button
                            theme={ButtonTheme.PRIMARY}
                            onClick={() => nextStepHandler(stepData?.action?.linkOnStep)}
                        >
                            Устроиться на работу
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};
